import { getTicketRates } from "@simplyk/common";

export const OCCURRENCE_ID_QUERY_PARAM = "occurrenceId";

interface OccurrenceRateAvailability {
  remainingTickets?: number | null;
  isAddOn?: boolean | null;
}

interface OccurrenceWithRatesObject {
  occurrence?: {
    id: string;
    startUtc?: number | Date | string | null;
    endUtc?: number | Date | string | null;
    closed?: boolean | null | undefined;
  } | null;
  rates?: OccurrenceRateAvailability[] | null;
}

export const areNonAddOnRatesSoldOut = (rates: OccurrenceRateAvailability[] | null | undefined): boolean => {
  const ticketRates = getTicketRates(rates);
  if (ticketRates.length === 0) {
    return false;
  }
  return ticketRates.every(
    (rate) => rate.remainingTickets !== undefined && rate.remainingTickets !== null && rate.remainingTickets <= 0
  );
};

export const generateMenuItemOccurrences = (occurrencesWithRates: OccurrenceWithRatesObject[]) =>
  occurrencesWithRates
    .filter((occurrencesWithRatesItem) => occurrencesWithRatesItem.occurrence !== null)
    .map((occurrencesWithRatesItem) => {
      return {
        occurrenceId: occurrencesWithRatesItem?.occurrence?.id,
        startUtc: occurrencesWithRatesItem?.occurrence?.startUtc,
        endUtc: occurrencesWithRatesItem?.occurrence?.endUtc,
        isClosed: occurrencesWithRatesItem?.occurrence?.closed,
        isDisabled: areNonAddOnRatesSoldOut(occurrencesWithRatesItem.rates),
      };
    });
